// 定义埋点类型的枚举
export enum TrackingEventType {
  /** 点击 */
  Click = 1,
  /** 曝光 */
  Exposure = 2,
}

// 定义平台的枚举
export enum TrackingPlatform {
  App = 1,
  H5 = 2,
  Pc = 3,
}

export enum TrackingEventID {
  /** 低价商品卡点击 */
  LowPriceProductCardClick = 10009,
  /** 商品详情相关 */
  ProductDetails = 10023,
  /** 页面首次进入 */
  PageFirstEnter = 10027,
  /** 商品卡点击跳转TT */
  ProductsToTTClick = 10029,
  /** 弹框中的下载按钮 */
  ProductsToTTDownload = 10030,
  /** 商品列表页下载按钮 */
  ProductsDownload = 10031,
  /** download */
  Download = 10007,
  /** 订单确认支付页曝光 */
  OrderConfirmPaymentPagePV = 10033,
  /** 订单确认支付页点击支付按钮 */
  OrderConfirmPaymentPageClickPayButton = 10034,
  /** 订单结果页曝光 */
  OrderResultPagePV = 10035,
  /** 年中大促商品卡埋点 */
  MidYearProductCard = 10036,
  /** 挂链弹窗 */
  DownloadMaskExposure = 10038,
  /** 美妆商品卡点击 */
  BeautyProductCardClick = 10039,
  /** 高佣检测页面曝光 */
  HighCommCheckPageExposure = 10040,
  /** 开始检测按钮点击 */
  HighCommCheckPageClickStart = 10041,
  /** 高佣换链点击*/
  HighCommCheckPageClickUpgrade = 10042,
  /** explore yoofinds点击 */
  HighCommCheckPageClickExplore = 10043,
  /** 广告任务商品卡点击 */
  AdTaskProductCardClick = 10045,
  /** 广告任务申请按钮点击 */
  AdTaskGoJoinClick = 10046,
  /** 广告任务页面*/
  AdTaskPage = 10047,
  /** ai打榜赛规则页点击 Click here to fill in */
  Bf2025AiRulesPageBtnClick = 10048,
  /**  黑5AI页面规则 */
  Bf2025AiRuleClick = 10049,
  /**  黑5AI Ranking列表 */
  Bf2025AiRankingClick = 10050,
  /**  黑5AI Join页面 */
  Bf2025AiJoinPage = 10051,
  /** 黑五GMV商品卡点击 */
  Bf2025GmvProductCardClick = 10052,
  /** 黑五广告商品卡点击 */
  Bf2025AdProductCardClick = 10053,
  /** 广告任务2*/
  AdTask2JoinClick = 10054,
  /** 广告任务页面进入 */
  AdTaskDetailPageEnter = 10055,
  /** 圣诞任务中心 各个按钮点击数 */
  Christmas2025TaskCenterBtnClick = 10056,
  /** 圣诞任务中心 GMV 打榜赛商品卡 点击数 */
  Christmas2025GmvProductCardClick = 10057,
  /** 圣诞任务中心 GMV 打榜赛商品卡 曝光数 */
  Christmas2025GmvProductCardExposure = 10058,
  /** 圣诞活动专区各个按钮点击数 */
  Christmas2025ZoneBtnClick = 10059,
  /** 情人节任务中心 GMV 打榜赛特供商品 点击数 */
  Lovers2026GmvSpecialOfferClick = 10060,
  /** 情人节任务中心 GMV 打榜赛商品卡 点击数 */
  Lovers2026GmvProductCardClick = 10061,
  /** 情人节任务中心 GMV 打榜赛商品卡 曝光数 */
  Lovers2026GmvProductCardExposure = 10062,
  /** 情人节活动专区各个按钮点击数 */
  Lovers2026ZoneBtnClick = 10063,
}

export enum TrackingEventPageID {
  /** download */
  DownloadPage = 5,
  /** 低价商品卡页面 */
  LowPricePage = 6,
  /** 商品列表页 */
  ProductsPage = 17,
  /** 商品详情页 */
  ProductDetailsPage = 14,
  /** 订单确认支付页 */
  OrderConfirmPaymentPage = 19,
  /** 订单结果页 */
  OrderResultPage = 20,
  /** 年中大促页面 */
  MidYearSalePage = 21,
  /** 美妆精选页面 */
  BeautyPicksPage = 22,
  /** 高佣检测页面-首页 */
  HighCommCheckPage = 23,
  /** 高佣检测页面-检测中 */
  HighCommCheckPageStartRunning = 24,
  /** 高佣检测页面-检测结果 */
  HighCommCheckPageFinish = 25,
  /** 高佣检测页面-升级成功 */
  HighCommCheckUpgradeSuccess = 26,
  /** 广告任务列表页面 */
  AdTaskListPage = 28,
  /** 广告任务详情页面 */
  AdTaskDetailPage = 29,
  /** ai打榜赛规则页 */
  Bf2025AiRulesPage = 30,
  /** 黑5AI页面 */
  Bf2025AiPage = 31,
  /** 黑五GMV页面 */
  Bf2025GmvPage = 32,
  /** 黑五AD页面 */
  Bf2025AdPage = 33,
  /** 广告任务2详情页面 */
  AdTask2DetailPage = 34,
  /** 圣诞任务中心页面 */
  Christmas2025TaskCenterPage = 35,
  /** 圣诞任务中心 GMV 打榜赛页面 */
  Christmas2025GmvChallengePage = 36,
  /** 圣诞活动专区 Holiday Haul 页面 */
  Christmas2025ZoneHolidayHaulPage = 37,
  /** 圣诞活动专区 Holiday Haul 列表页面 */
  Christmas2025ZoneHolidayHaulListPage = 38,
  /** 圣诞活动专区 Glow Up 页面 */
  Christmas2025ZoneGlowUpPage = 39,
  /** 圣诞活动专区 Glow Up 列表页面 */
  Christmas2025ZoneGlowUpListPage = 40,
  /** 圣诞活动专区 Gift 页面 */
  Christmas2025ZoneGiftPage = 41,
  /** 圣诞活动专区 Gift 列表页面 */
  Christmas2025ZoneGiftListPage = 42,
  /** 情人节任务中心页面 */
  Lovers2026TaskCenterPage = 43,
  /** 情人节任务中心 GMV 打榜赛页面 */
  Lovers2026GmvChallengePage = 44,
  /** 情人节活动专区 Date Night Glam 页面 */
  Lovers2026ZoneDateNightGlamPage = 45,
  /** 情人节活动专区 Date Night Glam 列表页面 */
  Lovers2026ZoneDateNightGlamListPage = 46,
  /** 情人节活动专区 Daily life Romance 页面 */
  Lovers2026ZoneDailylifeRomancePage = 47,
  /** 情人节活动专区 Daily life Romance 列表页面 */
  Lovers2026ZoneDailylifeRomanceListPage = 48,
  /** 情人节活动专区 Heartfelt Gift Guide 页面 */
  Lovers2026ZoneHeartfeltGiftGuidePage = 49,
  /** 情人节活动专区 Heartfelt Gift Guide 列表页面 */
  Lovers2026ZoneHeartfeltGiftGuideListPage = 50,
}

export enum TrackingStatus {
  Click = 0,
  Success = 1,
}

export enum TrackingBtnId {
  DownloadBtn = 1,
}

export enum TrackingModuleId {}

export enum TrackingVisitSource {
  ProductDetails = "h5-share",
  MidYearPromotion = "midyear",
  BeautyPicks = "beautymakeup",
  LowPrice = "lowprice",
  Bf2025AiMashup = "bf2025ai",
  Bf2025Gmv = "bf2025gmv",
  Bf2025Ad = "bf2025ad",
  Christmas2025Gmv = "christmas-2025",
  Lovers2026Gmv = "valentine-2026",
  DeliverProductList = "deliver-productList",
}

export enum TrackingZoneName {
  ProductDetails = "h5-share",
  Incentive = "incentive",
  SuperCommission = "supercommission",
  FlashSale = "flashsale",
  DiscountSection = "discountsection",
  KeyLiveStream = "keylivestream",
  Category = "category",
  BeautyPicks = "beautymakeup",
  LowPrice = "lowprice",
  Bf2025AiMashup = "bf2025ai",
  Bf2025Gmv = "bf2025gmv",
  Bf2025Ad = "bf2025ad",
  Christmas2025Gmv = "christmas-ranking",
  Christmas2025HolidayHaul = "holiday-haul",
  Christmas2025GlowUp = "christmas-glow-up",
  Christmas2025Gift = "christmas-gift",
  Lovers2026Gmv = "valentine-ranking",
  Lovers2026DateNightGlam = "valentine-date-night-glam",
  Lovers2026DailylifeRomance = "valentine-dailylife-romance",
  Lovers2026HeartfeltGiftGuide = "valentine-heartfelt-gift-guide",
  DeliverProductList = "deliver-productList",
}

export enum TrackingAdTaskPageType {
  All = "1",
  Sample = "2",
  NoSample = "3",
}

/** 广告join埋点 点击join:2 点击join不符合gmv:5 点击join不符合view:6  */
export enum JoinAdTaskEventType {
  /** 点击join  */
  Join = "2",
  /** 点击join不符合gmv */
  InvalidGmv = "5",
  /** 点击join不符合view  */
  InvalidView = "6",
}
